<template>
<transition name="scale-in">
  <div v-show="visible" class="dialog-overlay" :class="{
    inactive: !visible
  }">
    <div class="z-dialog">
      <div class="z-dialog-header">
        <div class="z-dialog-header-title">
          <slot name="header" />
        </div>
        <button title="关闭" class="z-dialog-close-btn" @click="onCloseBtnClick"></button>
      </div>
      <div class="z-dialog-body">
        <slot />
      </div>
      <div v-if="$slots.footer" class="z-dialog-footer">
        <slot name="footer" />
      </div>
    </div>
  </div>
</transition>
</template>

<script>
export default {
  name: 'ZDialog',
  props: {
    visible: {
      type: Boolean
    }
  },
  methods: {
    close () {
      this.$emit('update:visible', false)
      this.$emit('close')
    },
    onCloseBtnClick () {
      this.close()
    }
  },
  mounted () {
    setTimeout(() => {
      document.body.appendChild(this.$el)
    }, 0)
  },
  beforeDestroy () {
    let {$el} = this

    if ($el.parentNode) {
      document.body.removeChild($el)
    }
  }
}
</script>

<style lang="scss">
.dialog-overlay {
  --border-color: var(--z-dialog-border-color, #eeeeee);

  position: fixed;
  display: flex;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  background: var(--z-dialog-overlay-bg, rgba(0, 0, 0, .55));
  overflow: auto;
  z-index: 999;

  &.inactive {
    pointer-events: none;
  }

  &.scale-in- {
    &enter,
    &leave-to {
      opacity: 0;

      > .z-dialog {
        transform: scale(0);
      }
    }

    &enter-active,
    &leave-active {
      transition: opacity .5s;

      > .z-dialog {
        transition: transform .2s;
      }
    }
  }

  > .z-dialog {
    display: flex;
    flex-direction: column;
    // min-width: var(--z-dialog-min-width);
    // width: var(--z-dialog-width, 520px);
    min-width: 25rem;
    min-height: var(--z-dialog-min-height);
    height: var(--z-dialog-height);
    margin: var(--z-dialog-margin, auto);
    border: var(--z-dialog-border-width, 1px) solid var(--border-color) {
      radius: var(--z-dialog-border-radius);
    };
    background: var(--z-dialog-bg, #ffffff);
    box-shadow: var(--z-dialog-box-shadow, 0 0 16px rgba(0, 0, 0, .12),0 16px 16px rgba(0, 0, 0, .24));
    overflow: hidden;
    transition: all .2s;
  }

  .z-dialog-header {
    display: grid;
    grid-template-columns: auto var(--z-dialog-header-height);
    grid-column-gap: 8px;
    align-items: center;
    height: var(--z-dialog-header-height);
    /*line-height: var(--z-dialog-header-height);*/
    border-bottom: 1px solid var(--border-color);
    color: var(--z-dialog-header-color);
    background-color: var(--z-dialog-header-bg-color);
    user-select: none;
  }

  .z-dialog-header-title {
    display: flex;
    align-items: center;
    padding: var(--z-dialog-header-title-padding, 0 15px);
    color: var(--z-dialog-header-title-color, #303133);
  }

  .z-dialog-body {
    font-size: var(--z-dialog-body-font-size, 14px);
    flex: 1;
    width: 100%;
    min-height: 0;
    padding: var(--z-dialog-body-padding, 15px);
    color: var(--z-dialog-body-color);
    background-color: var(--z-dialog-body-bg-color);
  }

  .z-dialog-footer {
    display: flex;
    align-items: center;
    justify-content: flex-end;
    gap: 10px;
    height: var(--z-dialog-footer-height, 54px);
    padding: var(--z-dialog-footer-padding, 10px 15px 11px);
    border-top: 1px solid var(--border-color);
    background-color: var(--z-dialog-footer-bg-color);

    > * {
      min-width: 120px;
      margin: 0 !important;
    }
  }

  .z-dialog-close-btn {
    grid-column: 2;
    display: flex;
    justify-content: center;
    align-items: center;
    height: 100%;
    outline: none;
    -webkit-mask: {
      image: url(./icon-close.svg);
      position: center;
      repeat: no-repeat;
    };
    background-color: var(--z-dialog-close-btn-color);
    cursor: pointer;

    &:hover {
      background-color: var(--z-dialog-close-btn-hover-color);
    }

    &:active {
      background-color: var(--z-dialog-close-btn-active-color);
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/ZDialog/index.vue